import { DisplayBenefitType, BenefitType, DisplayBenefitTypeTranslation, DisplayBenefitIconTypeTranslation, BenefitTypeLabel, BenefitTypeUnit } from '../enums';
/**
 * Mapowanie benefitu
 *
 * @param {(BenefitType | DisplayBenefitType)} val
 * @returns {DisplayBenefitType}
 */
function getDisplayBenefitType(val) {
    if (typeof val == 'number') {
        return BenefitType[val];
    }
    return val;
}
/**
 * Nazwa typu benefitu
 *
 * @export
 * @param {(BenefitType | DisplayBenefitType)} val
 * @returns {string}
 */
export function benefitType(val) {
    return DisplayBenefitTypeTranslation[getDisplayBenefitType(val)];
}
/**
 * Ikona typu benefitu
 *
 * @export
 * @param {(BenefitType | DisplayBenefitType)} val
 * @returns {string}
 */
export function benefitIconType(val) {
    return DisplayBenefitIconTypeTranslation[getDisplayBenefitType(val)];
}
/**
 * Label do inputa z rodzajem benefitu
 *
 * @export
 * @param {(DisplayBenefitType | string)} val
 * @returns {string}
 */
export function getBenefitTypeLabel(val) {
    return BenefitTypeLabel[val] || 'Wysokość rabatu*';
}
/**
 * Wartość jednostki benefitu
 *
 * @export
 * @param { any } val
 * @returns {string}
 */
export function benefitValue(val) {
    return val.value + BenefitTypeUnit[DisplayBenefitType[val.type]];
}
//# sourceMappingURL=benefitType.js.map